export default "__VITE_ASSET__CbShv43A__"